export default [
  'M37.48 13.36L20.49 1.46a.86.86 0 00-.97 0l-17 11.9c-.3.21-.43.6-.32.95s.44.59.81.59h3.4v22.09H3.9a.85.85 0 100 1.7h32.2a.85.85 0 100-1.7h-2.51V14.9h3.4c.37 0 .7-.24.81-.59a.835.835 0 00-.32-.95zM11.5 36.99H8.1V14.9h3.4v22.09zm5.1 0h-3.4V14.9h3.4v22.09zm5.1 0h-3.4V14.9h3.4v22.09zm5.1 0h-3.4V14.9h3.4v22.09zm5.1 0h-3.4V14.9h3.4v22.09zM5.7 13.2L20 3.19 34.3 13.2H5.7z',
];
